const TICKET_COUNT_DURATION_MS = 1600;

const easeOutQuad = (t: number): number => 1 - (1 - t) * (1 - t);

export const animateHeroTicketCount = (
  el: HTMLDivElement,
  from: number,
  to: number,
  onValue: (value: number) => void,
): (() => void) => {
  const start = Math.max(0, Math.floor(from));
  const end = Math.max(0, Math.floor(to));

  if (start === end) {
    onValue(end);
    el.classList.remove('is-counting');
    return () => undefined;
  }

  el.classList.add('is-counting');
  const startTime = performance.now();
  let rafId = 0;

  const tick = (now: number) => {
    const progress = Math.min((now - startTime) / TICKET_COUNT_DURATION_MS, 1);
    const value = Math.round(start + (end - start) * easeOutQuad(progress));
    onValue(value);

    if (progress < 1) {
      rafId = requestAnimationFrame(tick);
      return;
    }

    onValue(end);
    el.classList.remove('is-counting');
  };

  rafId = requestAnimationFrame(tick);

  return () => {
    cancelAnimationFrame(rafId);
    el.classList.remove('is-counting');
  };
};

export const CD_BOX_ENTRY_BASE_DELAY_S = 0.35;
export const CD_BOX_ENTRY_STAGGER_S = 0.07;
